import { createSlice } from "@reduxjs/toolkit";

const initialState: { editId: string | null } = {
  editId: null,
};

const stockPriceRegisterSlice = createSlice({
  name: "stockPriceRegister",
  initialState,
  reducers: {
    setEditDataId(state, action) {
      state.editId = action.payload;
    },
  },
});
export const stockPriceRegisterActions = stockPriceRegisterSlice.actions;
export default stockPriceRegisterSlice;
